import {Service} from "@/services/Service";

export class BusinessService extends Service {

    protected constructor() {
        super();
    }
}
